export var ACTIVITE_STATUS_COMPLETED = "completed";
export var ACTIVITE_STATUS_STARTED = "started";
export var ACTIVITE_CONTENT_TYPE_VIDEO = "video";
export var ACTIVITE_CONTENT_TYPE_FORM = "form";
export var ACTIVITE_CONTENT_TYPE_ORAL = "oral";
export var ACTIVITE_CONTENT_TYPE_GAME = "game";
